import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { INVOICE_GROUP_ENDPOINTS } from './invoice-group.endpoints';
import { InvoiceGroup } from './invoice-group.interface';

export class InvoiceGroupService {
   async getInvoiceGroups(companyId: number, query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<InvoiceGroup>>(`/companies/${companyId}/invoice-groups`, { params: { ...query } });
      return response.data;
   }
   async createInvoiceGroup(companyId: number, invoiceGroup: InvoiceGroup) {
      return await http
         .post(`/companies/${companyId}/invoice-groups`, invoiceGroup, { params: { append: 'scopes', embed: 'city' } })
         .then((response) => response.data);
   }
   async deleteInvoiceGroup(companyId: number, invoiceGroupId: number) {
      return await http.delete(`/companies/${companyId}/invoice-groups/${invoiceGroupId}`).then((response) => response.data);
   }
   async putInvoiceGroup(companyId: number, invoiceGroupId: number, invoiceGroup: InvoiceGroup) {
      return await http
         .put(`/companies/${companyId}/invoice-groups/${invoiceGroupId}`, invoiceGroup, { params: { append: 'scopes' } })
         .then((response) => response.data);
   }

   async archiveInvoiceGroup(companyId: number, invoiceGroupId: number) {
      return await http.delete(INVOICE_GROUP_ENDPOINTS.ARCHIVE(companyId, invoiceGroupId)).then((response) => response.data);
   }

   async restoreInvoiceGroup(companyId: number, invoiceGroupId: number) {
      return await http.patch(INVOICE_GROUP_ENDPOINTS.RESTORE_ARCHIVED(companyId, invoiceGroupId)).then((response) => response.data);
   }

   async deleteInvoiceGroupPermanently(companyId: number, invoiceGroupId: number) {
      return await http.delete(INVOICE_GROUP_ENDPOINTS.DELETE(companyId, invoiceGroupId)).then((response) => response.data);
   }
}
